import { render } from "./ProposalList.vue?vue&type=template&id=e93f2f52"
import script from "./ProposalList.vue?vue&type=script&lang=js"
export * from "./ProposalList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__